import React, {Component} from 'react';
import axios from 'axios';
import ModalComponent from '../../../components/ModalComponent';
import {FaCloud, FaSearch} from "react-icons/fa";
import {
    Card, CardBody, Table, UncontrolledButtonDropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle, InputGroup, Input, InputGroupAddon, Button,
} from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import ListVpsUsUserComponent from "../../../components/Customer/vps_us/ListVpsUsUserComponent";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";
import ToastContainer from "react-bootstrap/ToastContainer";
import Toast from "react-bootstrap/Toast";
import ListButtonVpsUsComponent from "../../../components/Customer/vps_us/ListButtonVpsUsComponent";

class ListVpsUsExpirePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listService: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            from: '',
            to: '',
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            qtt: 30,
            q: '',
            checkAll: false,
            os: 0,
            checkedStart: -1,
            btn_all: 'Chọn hành động',
            rq_table: {
                per_page: 10,
                page: 0,
                s: '',
                ms: '',
                order_by: 'id',
                order: 'desc',
                type: 'expire',
                typeList: 'search'
            },
            vpsToast: [],
            vpsUpdate: [],
            textVpsToast: '',
            typeToast: 1,
            errorNotification: false,
            messageErrorNotification: '',
            successNotification: false,
            messageSuccessNotification: '',
            order_by: '',
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListVps();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
            errorNotification: this.props.errorNotificationUser,
            messageErrorNotification: this.props.messageErrorNotificationUser,
            successNotification: this.props.successNotificationUser,
            messageSuccessNotification: this.props.messageSuccessNotificationUser,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }

        if (this.props.errorNotificationUser) {
            this.props.updateErrorNotiUser({
                error: false,
                message: ''
            });
        }
        if (this.props.successNotificationUser) {
            this.props.updateSuccessNotiUser({
                success: false,
                message: ''
            });
        }
    }

    getListVps = () => {
        this.setState({
            isLoading: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // let data = "?qtt=" + this.state.qtt + "&q=" + this.state.q + "&type=using";
        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization' : this.props.token,
                'dataAgency' : JSON.stringify(dataAuth)
            },
            params: this.state.rq_table
        }

        axios.get( process.env.REACT_APP_API_URL + '/api/vps-us/getListVpsUs', config)
            .then( (ref) => {
                if ( ref.data.error === 0 ) {
                    let vpsUpdate = [];
                    if (ref.data.content.data.length) {
                        ref.data.content.data.forEach( (vps) => {
                            if ( vps.status_vps === 'progressing' || vps.status_vps === 'rebuild' || vps.status_vps === 'reset_password'
                                || vps.status_vps === 'change_ip' || vps.status_vps === 'waiting'
                            ) {
                                vpsUpdate.push( vps.id );
                            }
                        })
                    }
                    this.setState({
                        listService: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        from: ref.data.content.from,
                        to: ref.data.content.to,
                        currentPage: ref.data.content.current_page,
                        loadPage: false,
                        isLoading: false,
                        rq_table: ref.data.content.filters,
                        vpsUpdate: vpsUpdate
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                            isLoading: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu VPS thất bại',
                })
            })
    }


    changeQtt = async (event) => {
        let value = event.target.value;
        await this.setState({
            rq_table: {
                ...this.state.rq_table,
                per_page: value
            }
        })
        await this.getListVps();
    }

    search = (e) => {
        let text  = e.target.value;
        let r = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/; //192.168.1.1
        let r2 = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}:\d{1,5}\b/;
        let ip = '';
        let ips = '';
        if ( text.match(r2) ) {
            while (text.match(r2) != null) {
                ip = text.match(r2)[0];
                ips += ip + ',';
                text = text.replace(ip, '');
            }
        }
        if ( text.match(r) ) {
            while (text.match(r) != null) {
                ip = text.match(r)[0];
                ips += ip + ',';
                text = text.replace(ip, '');
            }
        }
        if (typeof(ips) !== 'undefined' && ips !== '') {
            ips = ips.slice(0, -1);
            ips = ips.replace('undefined', '');
            this.setState(
                {
                    rq_table: {
                        ...this.state.rq_table,
                        [e.target.name]: ips,
                        typeList: 'searchMulti'
                    }
                }
            )
        }
        else {
            this.setState(
                {
                    rq_table: {
                        ...this.state.rq_table,
                        [e.target.name]: e.target.value,
                        typeList: 'search'
                    }
                }
            )
        }
    }

    submitSearch = (e) => {
        if(e.key === 'Enter') {
            this.setState(
                {
                    currentPage: 0,
                    rq_table: {
                        ...this.state.rq_table,
                        page: 0
                    }
                },
                () => this.getListVps()
            )
        }
    }

    btnSearch = () => {
        this.setState(
            {
                currentPage: 0,
                rq_table: {
                    ...this.state.rq_table,
                    page: 0
                }
            },
            () => this.getListVps()
        )
    }

    sortVps = async () => {
        if (this.state.rq_table.order === '' || this.state.rq_table.order === 'ASC') {
            await this.setState(
                {
                    currentPage: 0,
                    rq_table: {
                        ...this.state.rq_table,
                        order: 'DESC',
                        order_by: 'next_due_date'
                    }
            })
            this.getListVps();
        } else {
            await this.setState(
                {
                    currentPage: 0,
                    rq_table: {
                        ...this.state.rq_table,
                        order: 'ASC',
                        order_by: 'next_due_date'
                    }
                })
            this.getListVps();
        }
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState(
            {
                currentPage: page,
                rq_table: {
                    ...this.state.rq_table,
                    page: page
                }
            },
            () => this.getListVps()
        )
    }

    btnChangeType = (type) => {
        this.setState(
            {
                rq_table: {
                    ...this.state.rq_table,
                    type: type,
                    page: 0
                }
            },
            () => this.getListVps()
        )
    }

    screentListService = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={20}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listService.length ) {
                return (
                    this.state.listService.map( (service, key) => {
                        return (
                            <ListVpsUsUserComponent
                                key={key}
                                service={service}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                                checkedService = { (actionKey) => this.checkedService(actionKey) }
                                checkedServiceShiftKey = { (actionKey, value) => this.checkedServiceShiftKey(actionKey, value) }
                                typePage = {this.state.rq_table.type}
                                changeAutoRenew = { (actionKey, type) => this.changeAutoRenew(actionKey, type) }
                                submitChangeDescription = { (actionKey, description) => this.submitChangeDescription(actionKey, description) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="20">
                            Không có VPS trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    submitChangeDescription = async (actionKey, description) => {
        let listService = this.state.listService;
        listService[actionKey].isDescription = !listService[actionKey].isDescription;
        await this.setState({
            listService: listService
        })

        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            vpsId: listService[actionKey].id,
            description: description,
            action: 'changeDescription'
        };

        await axios.put(process.env.REACT_APP_API_URL + '/api/vps/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.props.token,
                    'dataAgency': JSON.stringify(dataAuth)
                }
            }
        )
            .then((ref) => {
                // console.log(ref.data);
                if (ref.data.error > 9000) {
                    this.props.logOut();
                } else if (ref.data.error) {
                    listService[actionKey].isDescription = !listService[actionKey].isDescription;
                    this.setState({
                        listService: listService,
                        textVpsToast: ref.data.message,
                        typeToast: 1
                    })
                } else {
                    listService[actionKey].description = description;
                    listService[actionKey].isDescription = !listService[actionKey].isDescription;
                    this.setState({
                        listService: listService,
                        textVpsToast: ref.data.message,
                        typeToast: 1
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch(() => {
                this.setState({})
            })

        // this.setState({
        //     listService: listService,
        //     checkedStart: actionKey
        // })
    }

    changeAutoRenew = (actionKey, type) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = {
            vpsId: this.state.listService[actionKey].id,
            type: type
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/vps-us/autoRenewVps', data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    let listService = this.state.listService;
                    listService[actionKey].autorefund = !listService[actionKey].autorefund;
                    this.setState({
                        listService: listService,
                        textVpsToast: ref.data.message,
                        typeToast: 1
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            textVpsToast: ref.data.message,
                            typeToast: 1
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    textVpsToast: 'Lỗi. Truy vấn tự động gia hạn không thành công',
                    typeToast: 1
                })
            })
    }

    checkedService  = (actionKey) => {
        let listService = this.state.listService;
        listService[actionKey].checked = !listService[actionKey].checked;
        this.setState({
            listService: listService,
            checkedStart: actionKey
        })
    }

    checkedServiceShiftKey = (actionKey, value) => {
        if ( this.state.checkedStart !== -1 ) {
            let listService = this.state.listService;
            let n = Math.abs( actionKey - this.state.checkedStart );
            let i = this.state.checkedStart;
            let k = actionKey;
            if ( actionKey < this.state.checkedStart ) {
                i = actionKey;
                k = this.state.checkedStart;
            }
            for (i; i <= n; i++) {
                listService[i].checked = value;
            }
            this.setState({
                listService: listService,
                checkedStart: k
            })
        } else {
            let listService = this.state.listService;
            listService[actionKey].checked = !listService[actionKey].checked;
            this.setState({
                listService: listService,
                checkedStart: actionKey
            })
        }
    }

    checkAll = (event) => {
        // console.log("da den")
        let value = event.target.checked;
        let listService = this.state.listService;
        listService.forEach( service => {
            service.checked = value;
        })
        this.setState({
            checkAll: value,
            listService: listService
        })
    }

    showModal = (key, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'on' ) {
            titleModal = 'Bật VPS US';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'off' ) {
            titleModal = 'Tắt VPS US';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'restart' ) {
            titleModal = 'Khởi động lại VPS US';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'rebuild' ) {
            titleModal = 'Yêu cầu cài đặt lại VPS US';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'delete' ) {
            titleModal = 'Hủy VPS US';
            modalBody = this.modalBody(key, action);
        }
        else if ( action === 'expire' ) {
            titleModal = 'Yêu cầu gia hạn VPS US';
            modalBody = this.modalBody(key, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: key,
            alert: {
                error: false,
                message: ''
            },
        })
    }

    modalBody = (key, action) => {
        if ( action === 'on' ) {
            return (
                <div className="text-center">
                    Bạn có muốn bật dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'off' ) {
            return (
                <div className="text-center">
                    Bạn có muốn tắt dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'restart' ) {
            return (
                <div className="text-center">
                    Bạn có muốn khởi động lại dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'rebuild' ) {
            return (
                <div className="text-center">
                    Bạn có muốn cài đặt lại dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'delete' ) {
            return (
                <div className="text-center">
                    Bạn có muốn hủy dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'expire' ) {
            return (
                <div className="text-center">
                    Bạn có muốn gia hạn dịch vụ VPS <b className="text-danger">(ip: { this.state.listService[key].ip })</b> này không?
                </div>
            )
        }
        else if ( action === 'finish_expire' ) {
            return (
                <div className="text-center">
                    Yêu cầu gia hạn VPS thành công. Quý khách vui lòng bấm <a className="btn btn-sm btn-primary" href="/" onClick={ () => this.redirectDetailOrder() }> vào đây </a> để thanh toán hoàn thành quá trình gia hạn.
                </div>
            )
        }
        else if ( action === 'rebuild_chosse_vps' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn hệ điều hành</label>
                    <select className="form-control text-center" name="os" id="choose_vps" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (os, keyOs) => (
                                <option value={ os.id } key={keyOs}>{ os.os }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
        else if ( action === 'confirm_expire' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn thời gian gia hạn</label>
                    <select className="form-control text-center" name="billingCycle" id="billingCycle" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (billingCycle, keyBc) => (
                                <option value={ billingCycle.id } key={keyBc}>{ billingCycle.value }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
    }

    redirectDetailOrder = () => {
        let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
        this.hiddenModal();
        window.open(link, '_blank');
    }

    hiddenModal = () => {
        this.setState({
            action: '',
            isModal: false,
        })
    }

    confirmModal = () => {
        if ( this.state.action === 'finish_expire' ) {
            let link = "/don-dat-hang/" + this.state.orderId + "/chi-tiet-don-dat-hang.html";
            window.open(link, '_blank');
            this.hiddenModal();
        }
        else {
            let listVps = [];
            if ( this.state.listService.length ) {
                this.state.listService.forEach( (service) => {
                    if (service.checked) {
                        listVps.push(service.id);
                    }
                })
            }

            this.setState({
                btnConfirmDisabled: true,
                isSpinner: true,
                isBtnConfirm: false,
                alert: {
                    error: false,
                    message: ''
                }
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                vpsId: this.state.listService[ this.state.actionKey ].id,
                action: this.state.action,
                billingCycle: this.state.billingCycle,
                os: this.state.os,
                listVps: listVps
            };

            axios.put( process.env.REACT_APP_API_URL + '/api/vps-us/action', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        isSpinner: false,
                    });
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error ) {
                        this.setState({
                            contentModal: {
                                modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                title: this.state.contentModal.title
                            },
                        })
                    }
                    else {
                        if ( this.state.action === 'rebuild' ) {
                            let titleModal = 'Yêu cầu cài đặt lại VPS US';
                            let modalBody = this.modalBody( ref.data.content , 'rebuild_chosse_vps');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                os: ref.data.content[0].id,
                                isBtnConfirm: true,
                                isSpinner: false,
                                action: 'rebuild_chosse_vps'
                            })
                        }
                        else if ( this.state.action === 'rebuildAll' ) {
                            let titleModal = 'Yêu cầu cài đặt lại VPS US';
                            let modalBody = this.modalBodyAll( 'rebuild_chosse_vps', ref.data.content );
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                os: ref.data.content[0].id,
                                isBtnConfirm: true,
                                isSpinner: false,
                                action: 'rebuild_chosse_vps_all'
                            })
                        }
                        else if ( this.state.action === 'expire' ) {
                            let titleModal = 'Yêu cầu gia hạn VPS US';
                            let modalBody = this.modalBody( ref.data.content , 'confirm_expire');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                billingCycle: ref.data.content[0].id,
                                isBtnConfirm: true,
                                isSpinner: false,
                                action: 'confirm_expire',
                                orderId: 0
                            })
                        }
                        else if ( this.state.action === 'confirm_expire' ) {
                            let titleModal = 'Yêu cầu gia hạn VPS US';
                            let modalBody = this.modalBody( ref.data.content , 'finish_expire');
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                isBtnConfirm: true,
                                btnPayment: true,
                                isSpinner: false,
                                action: 'finish_expire',
                                orderId: ref.data.content
                            })
                        }
                        else if ( this.state.action === 'expiredAll' ) {
                            let titleModal = 'Yêu cầu gia hạn VPS US';
                            let modalBody = this.modalBodyAll( 'confirm_expire', ref.data.content );
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                billingCycle: ref.data.content[0].id,
                                isBtnConfirm: true,
                                isSpinner: false,
                                action: 'confirm_expire_all',
                                orderId: 0
                            })
                        }
                        else if ( this.state.action === 'confirm_expire_all' ) {
                            let titleModal = 'Yêu cầu gia hạn VPS US';
                            let modalBody = this.modalBodyAll( 'finish_expire', ref.data.content );
                            this.setState({
                                btnConfirmDisabled: false,
                                contentModal: {
                                    modalBody: modalBody,
                                    title: titleModal
                                },
                                isBtnConfirm: true,
                                btnPayment: true,
                                isSpinner: false,
                                action: 'finish_expire',
                                orderId: ref.data.content
                            })
                        }
                        else {
                            if ( !ref.data.error ) {
                                window.scrollTo(0, 0);
                                this.getListVps();
                            }
                            this.setState({
                                contentModal: {
                                    modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                                    title: this.state.contentModal.title
                                },
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( () => {
                    this.setState({
                        isSpinner: false,
                        contentModal: {
                            title: this.state.contentModal.title,
                            modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                        },
                    })
                })
        }
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
        if ( this.state.errorNotification ) {
            return (
                <>
                    <Alert color="danger">
                        { this.state.messageErrorNotification }
                    </Alert>
                </>
            );
        }
        if ( this.state.successNotification ) {
            return (
                <>
                    <Alert color="success">
                        { this.state.messageSuccessNotification }
                    </Alert>
                </>
            );
        }
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.setState({
            [name]: value
        });
    }

    showModalAll = (action) => {
        // console.log(action)
        let slc = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    slc++;
                }
            })
        }
        if ( slc ) {
            let titleModal;
            let modalBody;
            if ( action === 'onAll' ) {
                titleModal = 'Bật VPS US';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'offAll' ) {
                titleModal = 'Tắt VPS US';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'restartAll' ) {
                titleModal = 'Khởi động lại VPS US';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'rebuildAll' ) {
                titleModal = 'Yêu cầu cài đặt lại VPS US';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'cancelAll' ) {
                titleModal = 'Hủy VPS US';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'expiredAll' ) {
                titleModal = 'Yêu cầu gia hạn VPS US';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'onAutoRefund' ) {
                titleModal = 'Yêu cầu bật tự động gia hạn VPS';
                modalBody = this.modalBodyAll(action, 0);
            }
            else if ( action === 'offAutoRefund' ) {
                titleModal = 'Yêu cầu tắt tự động gia hạn VPS';
                modalBody = this.modalBodyAll(action, 0);
            }
            this.setState({
                action: action,
                isModal: true,
                btnConfirmDisabled: false,
                contentModal: {
                    modalBody: modalBody,
                    title: titleModal
                },
                isBtnConfirm: true,
                isSpinner: false,
                alert: {
                    error: false,
                    message: ''
                },
            })
        }
        else {
            alert("Vui lòng chọn 1 hoặc nhiều VPS");
        }
    }

    modalBodyAll = (action, key) => {
        if ( action === 'onAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn bật các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'offAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn tắt các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'restartAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn khởi động các dịch vụ VPS này không?
                </div>
            )
        }
            // else if ( action === 'rebuildAll' ) {
            //     return (
            //         <div className="text-center">
            //             Bạn có muốn cài đặt lại các dịch vụ VPS này không?
            //         </div>
            //     )
        // }
        else if ( action === 'cancelAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn hủy các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'onAutoRefund' ) {
            return (
                <div className="text-center">
                    Bạn có muốn bật tự động gia hạn các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'offAutoRefund' ) {
            return (
                <div className="text-center">
                    Bạn có muốn tắt tự động gia hạn các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'expiredAll' ) {
            return (
                <div className="text-center">
                    Bạn có muốn gia hạn các dịch vụ VPS này không?
                </div>
            )
        }
        else if ( action === 'finish_expire' ) {
            return (
                <div className="text-center">
                    Yêu cầu gia hạn VPS thành công. Quý khách vui lòng bấm <a href="/" className="btn btn-sm btn-primary" onClick={ () => this.redirectDetailOrder() }> vào đây </a> để thanh toán hoàn thành quá trình gia hạn.
                </div>
            )
        }
        else if ( action === 'rebuild_chosse_vps' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn hệ điều hành</label>
                    <select className="form-control text-center" name="os" id="choose_vps" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (os, keyOs) => (
                                <option value={ os.id } key={keyOs}>{ os.os }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
        else if ( action === 'confirm_expire' ) {
            return (
                <div className="text-center">
                    <label htmlFor="choose_vps">Chọn thời gian gia hạn</label>
                    <select className="form-control text-center" name="billingCycle" id="billingCycle" onChange={this.changeInput} defaultValue={key[0].id}>
                        {
                            key.map( (billingCycle, keyBc) => (
                                <option value={ billingCycle.id } key={keyBc}>{ billingCycle.value }</option>
                            ))
                        }
                    </select>
                </div>
            )
        }
    }

    loadQttChecked = () => {
        let n = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( service => {
                if ( service.checked ) {
                    n++;
                }
            })
        }
        return (n);
    }

    showToast = () => {
        if ( this.state.typeToast !== 0 ){
            if ( this.state.typeToast === 1 ) {
                return (
                    <ToastContainer className="p-3" position="top-end">
                        <Toast
                            className="d-inline-block m-1"
                            bg="Success"
                            onClose={() => this.hiddenToast(9999)} show={this.state.textVpsToast} delay={3000} autohide
                        >
                            <Toast.Header closeButton={false}>
                                <strong className="me-auto">VPS</strong>
                            </Toast.Header>
                            <Toast.Body>{ this.state.textVpsToast }</Toast.Body>
                        </Toast>
                    </ToastContainer>
                )
            }
            else {
                if ( this.state.vpsToast.length ) {
                    this.state.vpsToast.forEach( (vps, key) => {
                        return (
                            <ToastContainer className="p-3" position="top-end" key={key}>
                                <Toast
                                    className="d-inline-block m-1"
                                    bg="Success"
                                    onClose={() => this.hiddenToast(key)} show="VPS cài đặt thành công" delay={3000} autohide
                                >
                                    <Toast.Header closeButton={false}>
                                        <strong className="me-auto">VPS</strong>
                                    </Toast.Header>
                                    <Toast.Body>VPS { vps.ip } cài đặt thành công</Toast.Body>
                                </Toast>
                            </ToastContainer>
                        )
                    })
                }
            }
        }
    }

    hiddenToast = (key) => {
        if (key === 9999) {
            this.setState({
                typeToast: 0,
                textVpsToast: '',
            })
        } else {
            let vpsToast = this.state.vpsToast;
            vpsToast[key].toast = false;
            this.setState({
                typeToast: 0,
                vpsToast: vpsToast
            })
        }
    }

    changeUser = () => {
        let slc = '';
        let n = 0;
        if ( this.state.listService.length ) {
            this.state.listService.forEach( (service) => {
                if (service.checked) {
                    slc += service.id + ",";
                    n++;
                }
            })
        }
        // console.log( slc.slice( 0, -1 ) );
        if ( n ) {
            this.props.redirectChangeUser("listVpsId=" + slc.slice( 0, -1 ));
        }
        else {
            alert('Vui lòng chọn một hoặc nhiều VPS');
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={ `Dịch vụ VPS US hết hạn`} page={"VPS US"} icon={<FaCloud className="breadcrumb-icon"/>} />
                            <div className="list-button">
                                <ListButtonVpsUsComponent active="expired" />
                            </div>
                            <hr/>
                            <Card>
                                <CardBody className="table-responsive">
                                    <div className="row">
                                        <div className="col-md-5 form-inline">
                                            <select className="form-control form-control-sm m-1 ml-0" value={this.state.rq_table.per_page} onChange={ this.changeQtt }>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="200">200</option>
                                            </select>
                                            <UncontrolledButtonDropdown className="m-1">
                                                <DropdownToggle caret size="sm">
                                                    { this.state.btn_all }
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem onClick={ () => this.showModalAll('offAll') }>Tắt</DropdownItem>
                                                    <DropdownItem onClick={ () => this.showModalAll('onAll') }>Bật</DropdownItem>
                                                    <DropdownItem onClick={ () => this.showModalAll('restartAll') }>Khởi động lại</DropdownItem>
                                                    <DropdownItem onClick={ () => this.showModalAll('expiredAll') }>Gia hạn</DropdownItem>
                                                    <DropdownItem onClick={ () => this.showModalAll('onAutoRefund') }>Tự động gia hạn</DropdownItem>
                                                    <DropdownItem onClick={ () => this.showModalAll('offAutoRefund') }>Tắt tự động gia hạn</DropdownItem>
                                                    <DropdownItem onClick={ () => this.changeUser() }>Chuyển khách hàng</DropdownItem>
                                                    <DropdownItem onClick={ () => this.showModalAll('cancelAll') }>Hủy VPS</DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledButtonDropdown>
                                        </div>
                                        <div className="col-md-7">
                                            <InputGroup className="input-group-sm m-1">
                                                <Input
                                                    id="search"
                                                    name="s"
                                                    placeholder="Tìm kiếm VPS theo IP"
                                                    onChange={ this.search }
                                                    onKeyPress={ this.submitSearch }
                                                    value={ this.state.rq_table.s }
                                                />
                                                <InputGroupAddon addonType="prepend">
                                                    <Button onClick={ () => this.btnSearch() }> <FaSearch /> </Button>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </div>
                                        {
                                            this.state.listService.length ? (
                                                <div className="col-12 my-1">
                                                    Hiển thị từ { this.state.from } đến { this.state.to } / Tổng: { this.state.totalPage }
                                                </div>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        <div className="col-md-12 text-primary mb-3">
                                            <b>
                                                Đã chọn:
                                                <span className="qtt-checkbox"> { this.loadQttChecked() }</span> / <span
                                                className="total-item">{ this.state.listService.length }</span>
                                            </b>
                                        </div>
                                        <div className="col-md-12">
                                            {
                                                this.checkNotification()
                                            }
                                        </div>
                                        <div className="col col-md-12">
                                            <Table className="table-sm table-bordered table-hover rounded text-center table-service table-list">
                                                <thead className="primary">
                                                    <tr>
                                                        <th width="3%">
                                                            <input type="checkbox" value={this.state.checkAll}
                                                                   onChange={this.checkAll} />
                                                        </th>
                                                        <th width="10%">IP/State</th>
                                                        <th width="10%">Mật khẩu</th>
                                                        <th width="10%">Cấu hình</th>
                                                        <th width="7%">Ngày tạo</th>
                                                        <th width="7%"
                                                            onClick={ () => this.sortVps() }
                                                            className={`
                                                                    sorting 
                                                                    ${this.state.rq_table.order === '' ? 'order_by' : ''}
                                                                    ${this.state.rq_table.order === 'DESC' ? 'sorting_desc' : ''}
                                                                    ${this.state.rq_table.order === 'ASC' ? 'sorting_asc' : ''}
                                                                `}
                                                        >
                                                            Ngày kết thúc
                                                        </th>
                                                        <th width="7%">Tổng thời gian thuê</th>
                                                        <th width="7%">Chu kỳ thanh toán</th>
                                                        <th width="7%">Chi phí</th>
                                                        <th width="7%">Tự động gia hạn</th>
                                                        <th width="8%">Ghi chú</th>
                                                        <th width="8%">Trạng thái</th>
                                                        <th width="10%">Hành động</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    { this.screentListService() }
                                                </tbody>
                                                <tfoot className="card-footer clearfix">
                                                    <tr>
                                                        <td colSpan="20" className="link-right">
                                                            { this.paginate() }
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerVpsExpire' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListVpsUsExpirePage);